<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('book.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('book.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'books-search' }">{{ $t('book.list.search.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-nav pills fill>
          <b-nav-item :to="applicable_books_route">{{ $t('book.list.application.title') }}</b-nav-item>
          <b-nav-item :to="downloadable_books_route">{{ $t('book.list.download.title') }}</b-nav-item>
          <b-nav-item :to="{ name: 'books-search' }" active>{{ $t('book.list.search.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col-12">
          <application-list-button-toolbar></application-list-button-toolbar>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <b-form @submit="submitKeyword">
            <b-input-group size="lg">
              <b-form-input
                style="border-color: black; color: black"
                :placeholder="$t('book.list.search.search-bar.keyword-inputor.hint')"
                v-model="keyword"
              ></b-form-input>
              <b-input-group-append>
                <b-button type="submit" variant="primary">
                  {{ $t('book.list.search.search-bar.search-button.label') }}
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </div>
      </div>
      <div class="row mt-3" v-if="search_completed && books.length > 0">
        <div class="col-12">
          <b-form-select v-model="per_page" :options="per_page_options"></b-form-select>
        </div>
      </div>
      <book-card-list :books="books" v-if="search_completed && books.length > 0"></book-card-list>
      <div class="row mt-3" v-if="search_completed && show_next_page_notice">
        <div class="col-12">
          <b-alert show class="text-center font-weight-bold mb-0 border-0" style="font-size: 1.75rem; background-color: #F7F4EF; color: #ff3030;">
            {{ $t('book.list.modal.next-page-notice.message') }}
          </b-alert>
        </div>
      </div>
      <div class="row mt-3" v-if="search_completed && books.length > 0">
        <div class="col-12">
          <b-pagination
            size="lg"
            align="center"
            v-model="page"
            :total-rows="books_meta.total"
            :per-page="per_page"
            @change="pageChange"
          ></b-pagination>
        </div>
      </div>
      <div class="row mt-3" v-if="this.search_completed && books.length === 0">
        <div class="col-12">
          <h5 class="text-danger font-weight-bold">{{ $t('book.list.search.message.no-result') }}</h5>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import VueI18n from 'vue-i18n'

import { 
  BreadcrumbPlugin,
  ButtonPlugin,
  FormInputPlugin,
  FormPlugin,
  FormSelectPlugin,
  IconsPlugin,
  InputGroupPlugin,
  ModalPlugin,
  NavPlugin,
  OverlayPlugin,
  PaginationPlugin
} from 'bootstrap-vue'

import ApplicationListButtonToolbar from '@/components/button-toolbars/application-list-button-toolbar/ApplicationListButtonToolbar'
import BookCardList from '@/components/lists/BookCardList'

import i18n from '@/plugins/i18n.js'

import BookApiService from '@/services/budaedu-api-services/book-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormPlugin)
Vue.use(FormSelectPlugin)
Vue.use(IconsPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)
Vue.use(VueI18n)

Vue.use(BookApiService)

export default {
  i18n,
  name: 'books-search',
  props: {
    // 
  },
  data() {
    return {
      is_loading: false,
      keyword: '',
      search_completed: false,
      books: [],
      books_meta: { total: 0, current_page: null, last_page: null },
      per_page: 30,
      page: 1,
      book: {},
      book_cover: {},
      book_efiles: []
    }
  },
  computed: {
    applicable_books_route() {
      return {
        name: 'books',
        params: {
          group: 'applicable',
          language: (this.$i18n.locale === 'tw' ? 'chinese' : 'english')
        }
      }
    },
    downloadable_books_route() {
      return {
        name: 'books',
        params: {
          group: 'downloadable',
          language: (this.$i18n.locale === 'tw' ? 'chinese' : 'english')
        }
      }
    },
    per_page_options() {
      return [
        { value: 30, text: this.$t('paginator.items-per-page-selector.option.label', { size: 30 }) },
        { value: 50, text: this.$t('paginator.items-per-page-selector.option.label', { size: 50 }) },
        { value: 100, text: this.$t('paginator.items-per-page-selector.option.label', { size: 100 }) },
        { value: 200, text: this.$t('paginator.items-per-page-selector.option.label', { size: 200 }) }
      ]
    },
    show_next_page_notice() {
      return this.books_meta.last_page &&
        this.books_meta.current_page &&
        this.books_meta.last_page > this.books_meta.current_page &&
        this.books.filter(book => book.in_stock == 'Y').length == this.per_page
    },
    /**
     * 將使用者輸入的關鍵字（以空格隔開）解析為陣列
     * 同時支援半形空格、全形空格，並自動 trim 與合併連續空白
     */
    parsedKeywords() {
      return this.keyword.trim().split(/[\s\u3000]+/).filter(k => k.length > 0)
    }
  },
  watch: {
    per_page(new_value, old_value) {
      this.page = 1
      this.setBooksAndPaging()
    }
  },
  methods: {
    submitKeyword(event) {
      event.preventDefault()
      this.page = 1
      this.setBooksAndPaging()
    },
    pageChange(page) {
      this.page = page
      this.setBooksAndPaging()
    },
    async setBooksAndPaging() {
      this.search_completed = false
      this.is_loading = true
      this.books = []
      
      try {
        let items = {}
        let fron_cover = { url: 'img/common.jpg' }
        const additional = `filter[have_efile]&order=latest_storage_date,desc|created_at,desc&per_page=${this.per_page}&page=${this.page}`

        if (this.parsedKeywords.length > 1) {
          // 多關鍵字：以逗號分隔傳入 filter[of_keywords]（AND 邏輯）
          items = await this.$bookApiService.queryByKeywords(
            this.parsedKeywords.join(','),
            additional
          )
        } else if (this.parsedKeywords.length === 1) {
          // 單一關鍵字：維持原有 filter[of_keyword]
          items = await this.$bookApiService.queryByKeyword(
            this.parsedKeywords[0],
            additional
          )
        } else {
          items = await this.$bookApiService.query(additional)
        }

        const previewPromises = items.data.map(async (book) => {
          book.front_cover = await this.$bookApiService.getFrontCover(book, fron_cover)
        })
        await Promise.all(previewPromises)

        this.books = items.data
        this.books_meta = items.meta
      } finally {
        this.is_loading = false
        this.search_completed = true
      }
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    ApplicationListButtonToolbar,
    BookCardList
  },
  metaInfo() {
    return {
      title: this.$t('book.list.search.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>
